import { baseAPI } from 'services/baseApi';

export const appUsersApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    appUsersListing: builder.query({
      query: ({ limit, from, searchUser = '', status = '', ...params }) => ({
        url: `users/get-all?limit=${limit}&from=${from}&search=${searchUser}&status=${status}`,
        method: 'GET',
        params
      }),
      providesTags: ['APP_USERS_LIST']
    }),
    appUserClientsListing: builder.query({
      query: ({ limit, from, ...params }) => ({
        url: `users/get-all-clients?from=${from}&limit=${limit}`,
        method: 'GET',
        params
      }),
      providesTags: ['APP_USERS_LIST']
    }),
    appUserExpiredClientsListing: builder.query({
      query: ({ limit, from, ...params }) => ({
        url: `users/get-expired-clients?from=${from}&limit=${limit}`,
        method: 'GET',
        params
      }),
      providesTags: ['APP_USERS_LIST']
    }),
    appUserActiveClientsListing: builder.query({
      query: ({ limit, from, ...params }) => ({
        url: `users/get-active-clients?from=${from}&limit=${limit}`,
        method: 'GET',
        params
      }),
      providesTags: ['APP_USERS_LIST']
    }),
    onlineUsersListing: builder.query({
      query: () => ({
        url: 'user-online-status/online-users',
        method: 'GET'
      }),
      providesTags: ['ONLINE_USERS_LIST'],
      // Refetch every 30 seconds to keep status updated
      pollingInterval: 30000
    }),
    trainingUsersListing: builder.query({
      query: ({ trainer, limit, from, searchUser }) => ({
        url: `users?trainer=${trainer}&limit=${limit}&from=${from}&search=${searchUser}`,
        method: 'GET'
      }),
      providesTags: ['APP_USERS_LIST']
    }),
    addAppUser: builder.mutation({
      query: (payload) => ({
        url: 'users',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    updateAppUser: builder.mutation({
      query: ({ id, payload }) => ({
        url: 'users/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    // Food allergies live on the CLIENT so they hold for every plan and every coach —
    // see the note on `foodAllergies` in the backend user schema.
    updateAppUserFoodAllergies: builder.mutation({
      query: ({ id, payload }) => ({
        url: 'users/food-allergies/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    // NEW: update user notes only
    updateAppUserNotes: builder.mutation({
      query: ({ id, payload }) => ({
        url: 'users/notes/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    deleteAppUserPermanently: builder.mutation({
      query: ({ id }) => ({
        url: 'users/permanent/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    deleteAppUser: builder.mutation({
      query: ({ id }) => ({
        url: 'users/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    resetAppUserPassword: builder.mutation({
      query: (payload) => ({
        url: 'users/reset-password',
        method: 'POST',
        body: payload
      })
    }),
    restoreAppUser: builder.mutation({
      query: ({ id }) => ({
        url: 'users/restore/' + id,
        method: 'PUT'
      }),
      invalidatesTags: ['APP_USERS_LIST']
    }),
    appUserCountries: builder.query({
      query: () => ({
        url: 'users/get-countries',
        method: 'GET'
      }),
      providesTags: ['APP_USER_COUNTRIES']
    })
  })
});

export const {
  useAppUsersListingQuery,
  useAppUserClientsListingQuery,
  useAppUserActiveClientsListingQuery,
  useAppUserExpiredClientsListingQuery,
  useOnlineUsersListingQuery,
  useTrainingUsersListingQuery,
  useAddAppUserMutation,
  useUpdateAppUserMutation,
  useUpdateAppUserNotesMutation,
  useUpdateAppUserFoodAllergiesMutation,
  useDeleteAppUserPermanentlyMutation,
  useDeleteAppUserMutation,
  useResetAppUserPasswordMutation,
  useRestoreAppUserMutation,
  useAppUserCountriesQuery
} = appUsersApi;
